import React from "react";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-surface-elevated text-text-primary font-sans">
      <header className="border-b border-border px-6 md:px-20 py-4">
        <Link to="/" className="text-2xl font-bold text-text-primary">
          Traces
        </Link>
        <nav className="flex gap-4 mt-2 text-sm text-text-muted">
          <Link to="/about" className="hover:text-text-primary transition">About</Link>
          <Link to="/contact" className="hover:text-text-primary transition">Contact</Link>
          <Link to="/privacy" className="hover:text-text-primary transition">Privacy</Link>
          <Link to="/terms" className="hover:text-text-primary transition">Terms</Link>
          <Link to="/community-guidelines" className="hover:text-text-primary transition">Guidelines</Link>
        </nav>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-3">About Traces</h1>
          <p className="text-text-muted text-sm">Coming soon.</p>
        </div>
      </main>

      <footer className="py-10 px-6 md:px-20 border-t text-sm text-text-muted flex flex-col md:flex-row justify-between">
        <span>© {new Date().getFullYear()} Traces. All rights reserved.</span>
        <div className="flex gap-6 mt-4 md:mt-0">
          <Link to="/about" className="hover:text-text-primary transition">About</Link>
          <Link to="/contact" className="hover:text-text-primary transition">Contact</Link>
          <Link to="/privacy" className="hover:text-text-primary transition">Privacy</Link>
          <Link to="/terms" className="hover:text-text-primary transition">Terms</Link>
          <Link to="/community-guidelines" className="hover:text-text-primary transition">Guidelines</Link>
        </div>
      </footer>
    </div>
  );
}
